module.exports = __webpack_public_path__ + "img/Coors-Light-Landing-BG.90fd9ba1.jpg";